<div class="p-8">

    <h2 class="text-lg text-[#515151] font-semibold">{{data.title || ""}}</h2>
    <p class="text-[#808080]">
        {{data.message || ""}}
    </p>

    <div class="flex mt-8 justify-end gap-3">
        <app-button [mat-dialog-close]="false" [inputClass]="'!text-primary !bg-white !border !border-primary'"
            type="button">
            {{ data.cancelText || 'Cancel' }}
        </app-button>

        <app-button [mat-dialog-close]="true" type="button">
            {{ data.confirmText || 'Proceed' }}
        </app-button>
    </div>
</div>